import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-647f72be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12 p-md-6 p-lg-3 p-d-flex p-flex-column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "p-mb-2 p-text-bold" }, "Store:", -1 /* HOISTED */))
const _hoisted_4 = { class: "fake-input" }
const _hoisted_5 = { class: "p-col-12 p-md-6 p-lg-3 p-d-flex p-flex-column" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "p-mb-2 p-text-bold" }, "Riders:", -1 /* HOISTED */))
const _hoisted_7 = { class: "fake-input" }
const _hoisted_8 = { class: "p-col-12 p-md-6 p-lg-3 p-d-flex p-flex-column" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "p-mb-2 p-text-bold" }, "Data inizio:", -1 /* HOISTED */))
const _hoisted_10 = { class: "fake-input" }
const _hoisted_11 = { class: "p-col-12 p-md-6 p-lg-3 p-d-flex p-flex-column" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "p-mb-2 p-text-bold" }, "Data fine:", -1 /* HOISTED */))
const _hoisted_13 = { class: "fake-input" }
const _hoisted_14 = { class: "p-col-12 p-md-6 p-lg-1 p-d-flex p-flex-column" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "p-mb-2 p-text-bold" }, "Ora inizio:", -1 /* HOISTED */))
const _hoisted_16 = { class: "fake-input" }
const _hoisted_17 = { class: "p-col-12 p-md-6 p-lg-1 p-d-flex p-flex-column" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "p-mb-2 p-text-bold" }, "Ora fine:", -1 /* HOISTED */))
const _hoisted_19 = { class: "fake-input" }
const _hoisted_20 = { class: "p-col-12 p-md-6 p-lg-3 p-d-flex p-flex-column" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "p-mb-2 p-text-bold" }, "Veicolo:", -1 /* HOISTED */))
const _hoisted_22 = { class: "fake-input" }
const _hoisted_23 = {
  key: 1,
  class: "p-d-flex p-jc-center"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Nessun appuntamento prenotato", -1 /* HOISTED */))
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_GvSpinner = _resolveComponent("GvSpinner")!

  return (_ctx.existingAppointments && _ctx.existingAppointments.length > 0)
    ? (_openBlock(), _createBlock(_component_GvSpinner, {
        key: 0,
        "is-loading": _ctx.isLoading
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.existingAppointments, (item) => {
            return (_openBlock(), _createBlock(_component_Card, {
              class: "p-ml-3 p-mr-3 p-p-1 p-shadow-3",
              key: item.id
            }, {
              content: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.getTitle(item)), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, _toDisplayString(item.shop.name + " - " + item.shop.address), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.riders), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatDate(item.startTime)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatDate(item.endTime)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.formatTime(item.startTime)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.formatTime(item.endTime)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString(item.vehicle), 1 /* TEXT */)
                  ])
                ])
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["is-loading"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
}